import type {
  Application,
  ApplicationRequestDto,
  ApplicationResponseDto,
  UpdateApplicationArgs,
} from './applications.types';

export function applicationToApi(input: UpdateApplicationArgs): ApplicationRequestDto {
  return {
    ...(input.name !== undefined ? { name: input.name } : {}),
    ...(input.active !== undefined ? { active: input.active } : {}),
    ...(input.bundleIdentifiers !== undefined
      ? {
          bundle_identifiers: input.bundleIdentifiers.map(({ platform, bundleId }) => ({
            platform,
            bundle_id: bundleId,
          })),
        }
      : {}),
  };
}

export function applicationFromApi(dto: ApplicationResponseDto): Application {
  return {
    id: dto.id,
    appId: dto.app_id,
    accessKey: dto.access_key,
    name: dto.name,
    active: dto.active,
    bundleIdentifiers: dto.bundle_identifiers.map(({ platform, bundle_id }) => ({ platform, bundleId: bundle_id })),
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
    accountId: dto.account_id,
  };
}
